'use strict';
//***********************************************************************************
//***********************************************************************************
//******     CN-Map    **************************************************************
//******     Copyright(C) 2019-2020 EnerBIM                        ******************
//***********************************************************************************
//***********************************************************************************

//***********************************************************************************
//***********************************************************************************
//**** Unique label : a label to be used for various elements
//***********************************************************************************
//***********************************************************************************

import { cn_element } from './cn_element';

export class cn_unique_label extends cn_element {
    //***********************************************************************************
    /**
     * Constructor
     * @param {cn_element} parent
     */
    constructor(parent) {
        super(parent);

        //*** Model data
        this.name = "";
        this.element_class_name = "";
        this.children = [];
        
        this.element = null;
        this.storey = null;
    }

    //***********************************************************************************
    //**** serialize
    //***********************************************************************************
    serialize() {
        var json = this.serialize_element();
        json.name = this.name;
        json.element_class_name = this.element_class_name;
        if (this.children.length)
            json.children = this.children.map(c => c.serialize());
        return json;
    }

    static unserialize(json, parent) {
        if (typeof (json.ID) != 'string') return false;

        var ul = new cn_unique_label(parent);
        ul.unserialize_element(json);
        
        if (typeof (json.name) == 'string')
            ul.name = json.name;

        if (typeof (json.element_class_name) == 'string')
            ul.element_class_name = json.element_class_name;

        if (json.children && json.children.length)
            ul.children = json.children.map(c => cn_unique_label.unserialize(c,ul));

        return ul;
    }

    /**
     * recursive search for unique label
     * @param {string} element_class_name 
     * @param {string} id 
     * @returns {cn_unique_label}
     */
    find_unique_label(element_class_name, id) {
        if (this.ID == id && this.element_class_name == element_class_name) return this;
        
        let unique_label = null;
        this.children.some(ul => {
            unique_label = ul.find_unique_label('cn_space',id);
            return !!unique_label;
        });
        return unique_label;
    }

    clear_element() {
        this.element = null;
        this.children.forEach(c => c.clear_element());
    }
}

